import {POST, GET, DELETE} from "@/services/gateway";

const listExport = ({pagination, sourceType, dataTypes, dataProvider = 'BOX'}) => {
  return POST('recovery/export/list', {pagination, sourceType, dataTypes, dataProvider})
}

const deleteExport = (id) => {
  return DELETE(`recovery/export`, id)
}

const downloadExport = (id) => {
  return GET(`recovery/export/${id}/download`)
}

const cancelExport = (id) => {
  return GET(`box/drive/export/${id}/cancel`)
}

export {
  listExport,
  downloadExport,
  deleteExport,
  cancelExport,
}
